import * as React from "react";
import { NavLink, Link } from "react-router-dom";
import { Accessibility, Nav, Icon, LogoView } from "../frame";
import { ErrataWidget } from "./ErrataWidget.jsx";
import { SubmenuModel } from "./SidebarModel.js";
import * as cls from "./SidebarView.module.scss";
import { Config } from "../service/Config.js";
import Dropdown from "../component/DropDown.jsx";
import { useSelector } from "react-redux";
export { SidebarView, SidebarErrataView, SidebarLoaderView };
/**
 * Вид боковой панели.
 * @param {Object} props - Атрибуты элемента.
 * @param {SidebarModel} props.sidebar - Модель боковой панели.
 * @param {JSX.Element} props.children - Основное содержимое страницы.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function SidebarView({ sidebar, children }) {
  const className =
    cls.sidebar +
    " " +
    (sidebar.is_open ? cls.sidebar_open : cls.sidebar_closed);
  const navbar = sidebar.is_mobile ? null : sidebar.navbar;
  return (
    <div className={cls.sidebar_container}>
      <div className={className}>
        <SidebarToggler sidebar={sidebar} />
        <nav className={cls.sidebar_nav}>
          <SidebarLogo sidebar={sidebar} />
          <SidebarMenu sidebar={sidebar} />
        </nav>
      </div>
      <div className={cls.sidebar_body}>
        {navbar}
        {children}
      </div>
    </div>
  );
}
/**
 * Отображает процесс загрузки боковой панели.
 * @private
 */
function SidebarLoaderView(/*{ children }*/) {
  return "\u00a0\u231B Загрузка страницы...";
  //<div className={cls.sidebar_body}>{children}</div>;
}
/**
 * Отображает ошибку загрузки боковой панели.
 * @private
 */
function SidebarErrataView({ errata }) {
  return (
    <div className={cls.sidebar_body}>
      <h1>Ошибка загрузки</h1>
      <ErrataWidget errata={errata} />
    </div>
  );
}
function SidebarToggler({ sidebar }) {
  if (sidebar.is_mobile) return null;
  let className = cls.sidebar_toggler;
  if (!sidebar.is_open) className += " " + cls.rotate180;
  return (
    <div className={cls.sidebar_toggler_container}>
      <div className={className} onClick={sidebar.onToggle}>
        <Icon name="double_chevron_left" className={cls.sidebar_toggler_icon} />
      </div>
    </div>
  );
}
function SidebarLogo({ sidebar }) {
  if (sidebar.is_mobile) return <MobileNavbar sidebar={sidebar} />;
  const logo = sidebar.is_open ? sidebar.brand.logo : sidebar.brand.logo_small;
  const className = sidebar.is_open
    ? cls.sidebar_logo_large
    : cls.sidebar_logo_small;
  const title = sidebar.is_open ? (
    <div className={cls.sidebar_logo_title}>
      ЛИЧНЫЙ
      <br />
      КАБИНЕТ
    </div>
  ) : null;
  return (
    <Link
      to="/"
      className={className}
      activeclassname={cls.sidebar_link_active}
    >
      <div>
        <img src={logo} alt={sidebar.brand.name} />
        {title}
      </div>
    </Link>
  );
}
function MobileNavbar({ sidebar }) {
  const { contracts } = useSelector((state) => state.contract);

  const exit = {
    icon: "exit",
    name: "Разлогиниться",
    onClick: (event) => {
      event.preventDefault();
      sidebar.onSignOut();
    },
  };
  const toggler = {
    name: "Навигация",
    icon: "menu",
    href: "#menu",
    delimiter: true,
    onClick: sidebar.onToggle,
  };
  const menu = [Accessibility.OPEN, exit, toggler];
  Accessibility.menu = [toggler, exit];
  return (
    <div className={cls.mobile_navbar_container}>
      <div className={cls.mobile_navbar}>
        <LogoView brand={sidebar.brand} />
        {contracts && (
          <Dropdown onChange={(value) => value} isSearchable={false} />
        )}
        <Nav menu={menu} />
      </div>
      <Accessibility />
    </div>
  );
}
function SidebarMenu({ sidebar }) {
  if (sidebar.is_mobile && !sidebar.is_open) return null;
  return sidebar.menu.map((menu_item) =>
    menu_item.child ? (
      <Submenu key={menu_item.name} menu_item={menu_item} sidebar={sidebar} />
    ) : (
      <RootMenuItem
        key={menu_item.name}
        menu_item={menu_item}
        sidebar={sidebar}
      />
    )
  );
}
function RootMenuItem({ menu_item, sidebar }) {
  //if (!menu_item.active) return null;

  return (
    <div className={cls.submenu}>
      <SidebarLink
        menu_item={menu_item}
        sidebar={sidebar}
        className={cls.root_menu_item}
        activeclassname={cls.root_menu_item_active}
      >
        <div className={cls.menu_item_icon}>
          <Icon name={menu_item.icon} />
        </div>
        <MenuLabel menu_item={menu_item} sidebar={sidebar} />
      </SidebarLink>
    </div>
  );
}
//function MenuItem({ menu_item, sidebar }) {
//  return (
//    <SidebarLink menu_item={menu_item} sidebar={sidebar}>
//      <div className={cls.menu_item}>
//        <div className={cls.menu_item_icon}><Icon name={menu_item.icon ?? "none"} /></div>
//        <MenuLabel menu_item={menu_item} sidebar={sidebar} />
//      </div>
//    </SidebarLink>
//  );
//}
function MenuLabel({ menu_item, sidebar }) {
  if (!sidebar.is_open) return null;
  return <div className={cls.menu_label}>{menu_item.name}</div>;
}
function Submenu({ menu_item, sidebar }) {
  const [model, updateModel] = React.useState(new SubmenuModel(menu_item));
  model.onToggle = onToggle;
  React.useEffect(() => {
    if (!sidebar.is_open) {
      model.is_open = false;
      updateModel(new SubmenuModel(model));
    }
  }, [sidebar.is_open]);
  return <SubmenuView submenu={model} sidebar={sidebar} />;
  function onToggle(event) {
    event.preventDefault();
    model.is_open = !model.is_open;
    updateModel(new SubmenuModel(model));
    sidebar.onClickSubmenu();
  }
}
function SubmenuView({ submenu, sidebar }) {
  //if (!submenu.active) return null;
  return (
    <>
      <div className={cls.submenu} onClick={submenu.onToggle}>
        <div className={cls.menu_item}>
          <div className={cls.menu_item_icon}>
            <Icon name={submenu.icon} />
          </div>
          <MenuLabel menu_item={submenu} sidebar={sidebar} />
        </div>
        <SubmenuToggler submenu={submenu} sidebar={sidebar} />
      </div>
      <SubmenuNav submenu={submenu} sidebar={sidebar} />
    </>
  );
}
function SubmenuToggler({ submenu, sidebar }) {
  if (!sidebar.is_open) return null;
  let chevronClass = cls.submenu_toggler;
  if (!submenu.is_open) chevronClass += " " + cls.rotate90;
  return (
    <div className={chevronClass}>
      <Icon name={"chevron_down"} />
    </div>
  );
}
function SubmenuNav({ submenu, sidebar }) {
  if (!sidebar.is_open || !submenu.is_open) return null;
  const links = submenu.child.map((menu_item) => (
    <SubmenuItem key={menu_item.name} menu_item={menu_item} sidebar={sidebar} />
  ));
  return <div className={cls.submenu_nav}>{links}</div>;
}
function SubmenuItem({ menu_item, sidebar }) {
  //if (!menu_item.active) return null;
  return (
    <SidebarLink menu_item={menu_item} sidebar={sidebar}>
      <div className={cls.submenu_label}>{menu_item.name}</div>
    </SidebarLink>
  );
}
function SidebarLink({
  menu_item,
  className = cls.sidebar_link,
  activeclassname = cls.sidebar_link_active,
  children,
  sidebar,
}) {
  const student_service_url = Config.get("student_service");
  switch (menu_item.type) {
    case "external_lms_link":
      return (
        <a
          href={"#"}
          target="_blank"
          onClick={(e) => {
            e.preventDefault();
            window.open(student_service_url + menu_item.url);
          }}
          className={className}
        >
          {children}
        </a>
      );
    case "link":
      return (
        <a
          href={menu_item.url ?? "#"}
          target="_blank"
          onClick={sidebar.onClickMenuItem}
          className={className}
        >
          {children}
        </a>
      );
    default:
      return (
        <NavLink
          to={menu_item.path}
          onClick={sidebar.onClickMenuItem}
          className={className}
          activeclassname={activeclassname}
        >
          {children}
        </NavLink>
      );
  }
}
